import { Button } from "@ui/button"
import { cn } from "@/lib/utils"

interface ActionButtonProps {
    icon: React.ReactNode
    disabled?: boolean
    size?: "default" | "sm" | "lg" | "icon"
    variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link"
    className?: string
    onClick: () => void
}
export function ActionButton({ icon, disabled = false, size = "default", variant = "ghost", className, onClick }: Readonly<ActionButtonProps>) {
    return (
        <Button
            onClick={onClick}
            variant={variant}
            size={size}
            disabled={disabled}
            className={cn(className)}
        >
            {icon}
        </Button>
    )
}